import { wait } from '@change-corgi/core/async';
import type { TrackingFn } from '@change-corgi/core-react/tracking';
import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { copyToClipboard } from 'src/app/shared/utils/clipboard';

import { trackShare } from './track';

type OpenEducationModalResult = {
	waitForResult: () => Promise<{ successfulShare: boolean } | undefined>;
};

type Options = {
	trackingData: Record<string, string | number | boolean | undefined>;
	trackingEvents: Record<string, string>;
	openEducationModal: (options?: Record<string, unknown>) => OpenEducationModalResult;
};

export async function shareInstagram(
	url: string,
	{ trackingEvents, trackingData, openEducationModal }: Options,
	track: TrackingFn,
	i18nContext: UtilityContext['i18n'],
): Promise<boolean> {
	await copyToClipboard(url, i18nContext);

	trackShare(trackingEvents.success, trackingData, track);
	trackShare(trackingEvents.intent, trackingData, track);

	const successfulShare = await (async () => {
		try {
			const modalResult = await openEducationModal({}).waitForResult();
			// This is to prevent a race condition using the share slide up where the redirection in corgi is done before the device opens the Instagram app
			await wait(500);
			return !!modalResult?.successfulShare;
		} catch (error) {
			return false;
		}
	})();

	if (successfulShare) {
		trackShare(trackingEvents.continue, trackingData, track);
	} else {
		trackShare(trackingEvents.cancel, trackingData, track);
	}

	return successfulShare;
}
